<template>
  <div class="mb-6">
    <NtBreadcrumbs />
    <div class="mb-3 @5xl:flex @5xl:items-center @5xl:justify-between">
      <div class="min-w-0 flex-1">
        <NtHeading :level="1">
          {{ localHeading }}
        </NtHeading>
      </div>
      <div class="mt-4 flex shrink-0 @5xl:ml-4 @5xl:mt-0 gap-2 flex-wrap" id="actions">
        <slot v-if="$slots.actions" name="actions" />
      </div>
    </div>
    <p v-if="localIntroduction">{{ localIntroduction }}</p>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import NtBreadcrumbs from '../navigation/NtBreadcrumbs.vue'
import NtHeading from './NtHeading.vue'
import { useSystemStore } from '@/stores/system'

export default {
  components: { NtBreadcrumbs, NtHeading },
  props: {
    heading: {
      type: String,
      required: true
    },
    introduction: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState(useSystemStore, ['titleOverride', 'introOverride']),
    localHeading() {
      return this.titleOverride || this.heading.replace(/{{([A-z]+)}}/g, (m, p1) => this.$route.params[p1] || '')
    },
    localIntroduction() {
      return this.introOverride || this.introduction?.replace(/{{([A-z]+)}}/g, (m, p1) => this.$route.params[p1] || '')
    }
  }
}
</script>
